import moment from 'moment'

angular.module('webtrader').filter('moment', () => {
  return (format, input) => {
    if(!input)
      return '-'
    window.a = moment
    let dt = input === 'now'? moment() : moment(input)
    if(format == 'calendar') {
      if(Math.abs(dt.dayOfYear() - moment().dayOfYear()) < 2)
        dt = dt.format('HH:mm:ss')
      else
        dt = dt.format('L LT')
    } else if(format)
      dt = dt.format(format)
    return dt
  }
})
